import React from 'react';

const RenderComponentIfEnabled = (component: JSX.Element, enabled: boolean): JSX.Element => {
  if (!enabled) return <></>;
  return component;
};

export { RenderComponentIfEnabled };
